/* eslint-disable indent */
import numeral from 'numeral'

function numberFormat(num) {
  return numeral(num).format('0,0.00')
}

function numberFormat2(num) {
  return numeral(num).format('0[.]00')
}
function numberFormat4(num) {
  return numeral(num).format('0[.]0000')
}

function dateFormat(date) {
  try {
    const d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    const m =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1
    return date.getFullYear() + '-' + m + '-' + d
  } catch (error) {
    return date
  }
}

function showDocRef(data) {
  if (data) {
    if (data.length > 0) {
      return data
        .map(item => {
          if (item) {
            return `<a href="${item.link}" target="_blank">${item.label}</a>${
              item.participants !== undefined ? '<br>' + item.participants : ''
            }<br>${
              item.status_name !== undefined ? '<br>' + item.status_name : ''
            }`
          } else {
            return ''
          }
        })
        .join('<br>')
    } else {
      return ''
    }
  } else {
    return ''
  }
}

export function ajaxURLGenerator(url, headers, params) {
  // console.log(url, headers, params)
  if (params) {
    const urlNew = []
    if (params.sorters.length > 0) {
      urlNew.push(`sortBy=${params.sorters[0].field}`)
      urlNew.push(`sortDesc=${params.sorters[0].dir == 'desc'}`)
    }
    if (params.page) {
      urlNew.push(`page=${params.page}`)
    }
    if (params.size > 0) {
      urlNew.push(`per_page=${params.size}`)
    }
    if (params.filters.length > 0) {
      // urlNew.push(`filterBy=${params.filters[0].field}`)
      // urlNew.push(`filter=${params.filters[0].value}`)

      for (const field of params.filters) {
        urlNew.push(`filterBy[]=${field.field}`)
        urlNew.push(`filter[]=${field.value}`)
      }
    }
    const q = url.indexOf('?') == -1 ? '?' : '&'
    return urlNew.length ? `${url}${q}${urlNew.join('&')}` : url
  } else {
    return url
  }
}

function fillBorderColor(tableText) {
  // const colorCode = '#000000'
  // const borderStyle = 'border-bottom:1px solid hsl(0, 0%, 0%);border-left:1px solid hsl(0, 0%, 0%);border-right:1px solid hsl(0, 0%, 0%);border-top:1px solid hsl(0, 0%, 0%);'
  const borderStyle = 'border:1px solid hsl(0, 0%, 0%);'
  return tableText !== null
    ? tableText
        .replaceAll('<td style="', '<td style="' + borderStyle)
        .replaceAll('<table style="', '<table style="' + borderStyle)
        .replaceAll('<td>', '<td style="' + borderStyle + '">')
        .replaceAll('<table>', '<table style="' + borderStyle + '">')
    : ''
}

export default {
  numberFormat,
  numberFormat2,
  numberFormat4,
  dateFormat,
  showDocRef,
  ajaxURLGenerator,
  fillBorderColor
}
